import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ErrorBoundary: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center">
      <div className="container mx-auto px-4">
        <div className="flex justify-center">
          <div className="w-full md:w-2/3 lg:w-1/2 text-center">
            <div className="bg-white rounded-lg shadow-sm border-0">
              <div className="p-8 py-12">
               
                <div className="mb-6">
                  <div 
                    className="bg-blue-600 rounded-full inline-flex items-center justify-content-center mb-4 w-30 h-30"
                    style={{ width: '120px', height: '120px' }}
                  >
                    <i className="bi bi-question-circle-fill text-white" style={{ fontSize: '3rem' }}></i>
                  </div>
                </div>
                
                <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
                <h2 className="text-3xl mb-4">Page Not Found</h2>
                
                <p className="text-gray-600 mb-6 text-lg">
                  Sorry, we couldn't find the page you're looking for. 
                  The page might have been moved, deleted, or you entered an incorrect URL.
                </p>

                <div className="flex flex-col md:flex-row gap-3 justify-center mt-6">
                  <button 
                    className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg hover:bg-blue-700 transition-colors"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Go Back
                  </button>
                  
                  <Link 
                    to="/" 
                    className="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg text-lg hover:bg-blue-50 transition-colors"
                  >
                    <i className="bi bi-house me-2"></i>
                    Go to Home
                  </Link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;